import React from "react";
import { useSelector, useDispatch } from "react-redux";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { actionCreators } from "../redux/agreementsAnalysisSagas";
import { useDateFormat } from "../../../../hooks/useDateFormat";

const DatePicker = () => {
  const dispatch = useDispatch();
  const dateFormat = useDateFormat();

  const { startDate, endDate } = useSelector(
    (state) => state.agreementsAnalysis.selectedRequestDates
  );
  const { calendarEndDate, calendarStartDate } = useSelector(
    (state) => state.agreementsAnalysis.currentUser
  );

  const handleUpdateDates = (startDate, endDate) => {
    dispatch(actionCreators.updateDates({ startDate, endDate }));
  };

  return (
    <div className="select-box-no-width date-range-select-box">
      <p className="offers-title">Date</p>
      <ReactDatePicker
        displayFormat={dateFormat}
        startDate={startDate}
        endDate={endDate}
        calendarEndDate={calendarEndDate}
        isRangePicker
        minDate={calendarStartDate}
        updateDates={handleUpdateDates}
      />
    </div>
  );
};

export default DatePicker;
